import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import DisplayMocker from './main/DisplayMocker';
import store from './main/data/store';

import http from './utils/http';
import purecarsAPI from './api-purecars';

purecarsAPI({ http });

ReactDOM.render(
  <Provider store={store} >
    <DisplayMocker />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js